import { Component, LOCALE_ID, OnInit, TemplateRef } from '@angular/core';
import { AppointmentDate, AvailableHour, AvailableTime, GiftVoucherOptionType, InvoiceDetailType, Item, ItemCode, ProcessStatus, TimeGrouping } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import '@progress/kendo-angular-intl/locales/en/all';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-select-date-and-time',
  templateUrl: './select-date-and-time.component.html',
  styleUrls: ['./select-date-and-time.component.scss'],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-AU' }
  ],
})
export class SelectDateAndTimeComponent extends BaseComponent implements OnInit {

  public modalRef: BsModalRef;
  public calendarViewCount: number;

  public selectedTreatment: ItemCode[];
  public selectedTherapist: any;

  public availableSlots: AppointmentDate[] = [];
  public selectedSlot: AppointmentDate;
  public selectedHour: AvailableHour;
  public selectedHourGroup: TimeGrouping;
  public preferredDateAndTime: AvailableTime = null;

  public selectedDate: Date = new Date();
  public oldStartDate: Date = null;
  public oldEndDate: Date = null;

  public focusedDate: Date = new Date();
  public startDate: Date = new Date();
  public endDate: Date = new Date();
  public minDate: Date = new Date();

  public activeRangeEnd: any;
  public tdx: NodeListOf<Element>;
  public previousButton: any;
  public nextButton: any;

  public maxGuestCount = 1;

  public isConfirmButtonIsDisabled = true;
  public isPassSeven = false;

  @ViewChild('addConfirmation') addConfirmation: TemplateRef<any>;

  public firstAppointmentOnCart: any;

  public hasNewClientTreatment: boolean;

  ngOnInit(): void {
    this.app.spinner.show();

    this.app.activatedRoute.params.subscribe(params => {

    });

    this.baseTriggerChild.subscribe(event => {
      this.initialize();
    });

    this.start();
  }

  initialize(): void {
    if (localStorage.getItem(AppConstants.BookingProcessStatus) === ProcessStatus.ConfirmAppointment.toString()) {
      this.app.router.navigate([AppConstants.RouteServiceConfirmation]);
      return;
    }
    this.selectedTreatment = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment)) as ItemCode[];
    if (this.selectedTreatment === null) {
      this.showErrorMessage('Please choose a treatment');
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    this.selectedTherapist = JSON.parse(this.app.storageService.getItem(AppConstants.SelectedPractitioner)) as any;
    if (this.selectedTherapist === null) {
      this.showErrorMessage('Please choose a practitioner');
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    if (this.app.branch === null) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }

    if (this.app.basketItems != null && this.app.basketItems.length > 0) {
      for (let a = 0; a < this.app.basketItems.length; a++) {
        if (this.app.basketItems[a].invoiceDetailType == InvoiceDetailType.Service && this.firstAppointmentOnCart == null) {
          this.firstAppointmentOnCart = this.app.basketItems[a];
          break;
        }
      }
    }

    // Has New Client Treatment
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      if (!this.selectedTreatment[a].newClientTreatment) {
        this.hasNewClientTreatment = true;
      }
    }

    this.checkAvailableSlot();
  }

  checkAvailableSlot(): void {
    this.app.spinner.show();

    this.minDate = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate(), 0, 0, 0);
    this.calendarViewCount = this.app.config.calendarViewCount;
    this.maxGuestCount = 1;

    setTimeout((e) => {
      this.previousButton = document.getElementsByClassName('k-prev-view')[0];
      this.previousButton.addEventListener('click', () => {
        const startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
        startDate.setDate(this.startDate.getDate() - (this.app.config.bookingAvailableDaysChecking));
        setTimeout((n) => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.availableSlots = [];
          this.getStartAndEndDate(false, startDate);
        }, 100);
      });

      this.nextButton = document.getElementsByClassName('k-next-view')[0];
      this.nextButton.addEventListener('click', () => {
        const startDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate());
        startDate.setDate(startDate.getDate() + 1);
        this.selectedDate = startDate;
        setTimeout((n) => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.availableSlots = [];
          this.getStartAndEndDate(false, startDate);
        }, 100);
      });

      const calHeader = document.getElementsByClassName('k-calendar-header')[0];
      const btnToday = calHeader.querySelectorAll('.k-today');
      btnToday[0].addEventListener('click', () => {
        setTimeout(() => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.getStartAndEndDate(true);
        }, 100);
      });

    }, 100);

    let slotDate = null;
    if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedDate))) {
      slotDate = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedDate));
    }
    if (slotDate != null) {
      const date = this.app.dateService.getNewDate(slotDate.appointmentDate);
      if (date > this.minDate) {
        this.selectedDate = date;
      }
    }

    setTimeout((n) => {
      let startDate: Date = null;
      if (slotDate != null) {
        const table = document.getElementsByClassName('k-content')[0];
        this.tdx = table.querySelectorAll('tr > [data-cell-index]');
        const lastTd = this.tdx[this.tdx.length - 1];
        const date = new Date(Date.parse(lastTd.getAttribute('title').toString()));
        let startDay = 1;
        if (this.selectedDate.getMonth() < date.getMonth()) {
          if (this.selectedDate.getDate() > 15) { startDay = 10; }
        }
        startDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), startDay);
      }
      if (startDate < this.minDate) { startDate = this.minDate; }
      this.availableSlots = [];
      this.getStartAndEndDate(false, startDate, true);
    }, 100);
  }

  generateNext30Days(autoSelectDate: boolean = false): void {
    this.nextButton.click();
  }

  generateNext7Days(): void {

  }

  getStartAndEndDate(setTodayDate: boolean = false, newStartDate: Date = null, isFromInit: boolean = false): void {
    const table = document.getElementsByClassName('k-content')[0];
    this.tdx = table.querySelectorAll('tr > [data-cell-index]');

    Array.prototype.forEach.call(this.tdx, (e: Element) => {
      e.removeEventListener('onclick', () => { }, false);
      e.addEventListener('click', (event: any) => {
        if (this.availableSlots === null || this.availableSlots.length === 0) { return; }
        const nDate = new Date(Date.parse(
          this.app.stringService.isNotEmpty(event.target.title) ? event.target.title : event.target.parentNode.title));
        if (this.isDateBlocked(nDate)) { return; }
        for (const f of this.availableSlots) {
          if ((this.app.dateService.formatDate(nDate) === this.app.dateService.formatDate(this.app.dateService.getNewDate(f.appointmentDate)))) {
            if (f.availableTimes.length > 0) {
              // if (this.app.stringService.isEmpty(this.selectedTherapist.consultationTimes) || !this.hasNewClientTreatment) {
              //   this.getAvailableSlotPerDay(f.appointmentDate);
              // }
              // else {
              //   this.selectedSlot = f;
              //   this.selectedHourGroup = f.timeGroupings != null && f.timeGroupings.length > 0 ? f.timeGroupings[0] : null;
              // }              
              this.getAvailableSlotPerDay(f.appointmentDate);
            }
          }
        }
      });
    });

    const firstTd = this.tdx[0];
    if (this.app.stringService.isNotEmpty(firstTd.getAttribute('title'))) {
      const date = Date.parse(firstTd.getAttribute('title').toString());
      if (this.app.stringService.isNotEmpty(date)) { this.startDate = new Date(date); }
    }
    if (this.startDate < this.minDate) { this.startDate = this.minDate; }
    if (this.startDate <= this.minDate) { }

    // Get last date of the calendar
    const lastTd = this.tdx[this.tdx.length - 1];
    if (this.app.stringService.isNotEmpty(lastTd.getAttribute('title'))) {
      const date = Date.parse(lastTd.getAttribute('title').toString());
      if (this.app.stringService.isNotEmpty(date)) { this.endDate = new Date(date); }
      if (this.endDate < this.minDate) { this.endDate = this.minDate; }
    }

    // 30 Days
    if (this.app.config.enable30Days) {
      if (newStartDate != null) { this.startDate = newStartDate; }
      const lastDay = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0).getDate();
      const minusCheck = lastDay === 31 ? 0 : 1;
      this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
      this.endDate.setDate(this.endDate.getDate() + (this.app.config.bookingAvailableDaysChecking - minusCheck));
    }

    this.focusedDate = this.startDate;

    let retrieveNewAvailability = false;
    if (this.availableSlots != null && this.availableSlots.length > 0) {
      const x = this.app.dateService.getNewDate(this.availableSlots[0].appointmentDate);
      const y = this.app.dateService.getNewDate(this.availableSlots[this.availableSlots.length - 1].appointmentDate);
      if (this.app.dateService.formatDate(this.startDate) === this.app.dateService.formatDate(x) &&
        this.app.dateService.formatDate(this.endDate) === this.app.dateService.formatDate(y)) {
        if (this.availableSlots === null || this.availableSlots.length === 0) { return; }
        for (const f of this.availableSlots) {
          if ((this.app.dateService.formatDate(this.minDate) === this.app.dateService.formatDate(this.app.dateService.getNewDate(f.appointmentDate)))) {
            if (f.availableTimes.length > 0) {
              // if (this.app.stringService.isEmpty(this.selectedTherapist.consultationTimes) || !this.hasNewClientTreatment) {
              //   this.getAvailableSlotPerDay(f.appointmentDate);
              // }
              // else {
              //   this.selectedHourGroup = null;
              //   this.selectedHourGroup = f.timeGroupings != null && f.timeGroupings.length > 0 ? f.timeGroupings[0] : null;
              // }
              this.getAvailableSlotPerDay(f.appointmentDate);
            }
          }
        }
      }
      else {
        retrieveNewAvailability = true;
      }
    }
    else {
      retrieveNewAvailability = true;
    }

    if (retrieveNewAvailability) { this.getAvailableSlot(setTodayDate, isFromInit); }
    this.selectedDate = null;
  }

  getAvailableSlot(setTodayDate: boolean = false, isFromInit = false): void {

    const maxGuestCount = 1;

    const treatments = [];
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      const treatment = {
        treatmentId: this.selectedTreatment[a].treatmentId,
        staffId: this.selectedTherapist.therapistId,
        requiredTimes: null
      };

      if (this.app.stringService.isNotEmpty(this.selectedTherapist.consultationTimes) &&
        this.hasNewClientTreatment) {
        treatment.requiredTimes = this.selectedTherapist.consultationTimes;
      }
      treatments.push(treatment);
    }

    if (this.firstAppointmentOnCart != null) {
      var sevenDaysAfterFirstAppointment = this.app.dateService.addDays(this.firstAppointmentOnCart.endTime, 7);
      if (this.startDate > sevenDaysAfterFirstAppointment) {
        this.startDate = sevenDaysAfterFirstAppointment;
        this.endDate = sevenDaysAfterFirstAppointment;
      }
      else {
        this.endDate = sevenDaysAfterFirstAppointment;
      }
    }

    const m = {
      treatments,
      branchId: this.app.branch.branchId,
      startDate: this.app.dateService.formatDateTime(this.startDate),
      endDate: this.app.dateService.formatDateTime(this.endDate),
      guestCount: maxGuestCount
    };

    this.app.spinner.show();
    this.app.loadingDescription = 'Checking available dates...';
    this.app.webBookingService.GetAvailableSlots(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.availableSlots = data;

          const currentDateTime = new Date();
          const currentDate = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate());

          Array.prototype.forEach.call(this.tdx, (e: Element) => {
            // Get Date
            const date = new Date(Date.parse(e.getAttribute('title').toString()));
            let className = 'disabled ';

            if (date < currentDate) {
              className = 'past-date ';
            }

            if (this.availableSlots === null || this.availableSlots.length === 0) {
              e.className = className + 'no-roster';
              if ((className === 'disabled ' || className === 'past-date ') && e.removeEventListener) {
                e.removeEventListener('click', () => { }, false);
              }
              return;
            }

            for (const a of this.availableSlots) {
              // Auto Set Today Date
              let slotDate = null;
              let slotTime = null;
              if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedDate))) {
                slotDate = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedDate)) as AppointmentDate;
              }
              if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTime))) {
                slotTime = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTime)) as AvailableTime;
              }

              if (isFromInit &&
                slotDate != null &&
                slotTime != null &&
                this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(date) &&
                !this.isDateBlocked(date)) {

                this.focusedDate = this.app.dateService.getNewDate(slotTime.time);
                this.getAvailableSlotPerDay(slotTime.time, slotDate);
                className = 'meeting k-state-selected';
              }
              else if (setTodayDate &&
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.minDate) &&
                !this.isDateBlocked(date)) {
                this.selectedSlot = a;
                className = 'meeting k-state-selected';
              }
              else if (
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                a.availableTimes.length > 0 &&
                !this.isDateBlocked(date)) {
                className = 'meeting';
              }
              else if (
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                (a.availableTimes.length === 0 ||
                  this.isDateBlocked(date))) {
                className = 'no-schedule';
              }
            }
            e.className = className;
          });

        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });

    // if (this.app.stringService.isEmpty(this.selectedTherapist.consultationTimes) || !this.hasNewClientTreatment) {
    //   this.app.spinner.show();
    //   this.app.loadingDescription = 'Checking available dates...';
    //   this.app.webBookingService.GetAvailableSlots(m)
    //     .subscribe(
    //       data => {
    //         this.app.spinner.hide();
    //         this.availableSlots = data;

    //         const currentDateTime = new Date();
    //         const currentDate = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate());

    //         Array.prototype.forEach.call(this.tdx, (e: Element) => {
    //           // Get Date
    //           const date = new Date(Date.parse(e.getAttribute('title').toString()));
    //           let className = 'disabled ';

    //           if (date < currentDate) {
    //             className = 'past-date ';
    //           }

    //           if (this.availableSlots === null || this.availableSlots.length === 0) {
    //             e.className = className + 'no-roster';
    //             if ((className === 'disabled ' || className === 'past-date ') && e.removeEventListener) {
    //               e.removeEventListener('click', () => { }, false);
    //             }
    //             return;
    //           }

    //           for (const a of this.availableSlots) {
    //             // Auto Set Today Date
    //             let slotDate = null;
    //             let slotTime = null;
    //             if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedDate))){
    //               slotDate = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedDate)) as AppointmentDate;
    //             }
    //             if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTime))){
    //               slotTime = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTime)) as AvailableTime;
    //             }

    //             if (isFromInit &&
    //               slotDate != null &&
    //               slotTime != null &&
    //               this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(date) &&
    //               !this.isDateBlocked(date)) {

    //               this.focusedDate = this.app.dateService.getNewDate(slotTime.time);
    //               this.getAvailableSlotPerDay(slotTime.time, slotDate);
    //               className = 'meeting k-state-selected';
    //             }
    //             else if (setTodayDate &&
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.minDate) &&
    //               !this.isDateBlocked(date)) {
    //               this.selectedSlot = a;
    //               className = 'meeting k-state-selected';
    //             }
    //             else if (
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               a.availableTimes.length > 0 &&
    //               !this.isDateBlocked(date)) {
    //               className = 'meeting';
    //             }
    //             else if (
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               (a.availableTimes.length === 0 ||
    //                 this.isDateBlocked(date))) {
    //               className = 'no-schedule';
    //             }
    //           }
    //           e.className = className;
    //         });

    //       },
    //       error => {
    //         this.app.spinner.hide();
    //         this.showErrorMessage(error);
    //       });
    // }
    // else {
    //   this.app.spinner.show();
    //   this.app.loadingDescription = 'Checking available dates...';
    //   this.app.webBookingService.GetAvailableFromSpecificStaffTimes(m)
    //     .subscribe(
    //       data => {
    //         this.app.spinner.hide();
    //         this.availableSlots = data;

    //         const currentDateTime = new Date();
    //         const currentDate = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate());

    //         Array.prototype.forEach.call(this.tdx, (e: Element) => {
    //           // Get Date
    //           const date = new Date(Date.parse(e.getAttribute('title').toString()));
    //           let className = 'disabled ';

    //           if (date < currentDate) {
    //             className = 'past-date ';
    //           }

    //           if (this.availableSlots === null || this.availableSlots.length === 0) {
    //             e.className = className + 'no-roster';
    //             if ((className === 'disabled ' || className === 'past-date ') && e.removeEventListener) {
    //               e.removeEventListener('click', () => { }, false);
    //             }
    //             return;
    //           }

    //           for (const a of this.availableSlots) {
    //             // Auto Set Today Date
    //             let slotDate = null;
    //             let slotTime = null;
    //             if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedDate))){
    //               slotDate = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedDate)) as AppointmentDate;
    //             }
    //             if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTime))){
    //               slotTime = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTime)) as AvailableTime;
    //             }
                
    //             if (isFromInit &&
    //               slotDate != null &&
    //               slotTime != null &&
    //               this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(date) &&
    //               !this.isDateBlocked(date)) {
    //               this.focusedDate = this.app.dateService.getNewDate(slotTime.time);
    //               this.selectedSlot = slotDate;
    //               this.selectedHourGroup = this.selectedSlot.timeGroupings[0];
    //               if (slotDate != null && a.timeGroupings != null) {
    //                 for (const group of a.timeGroupings) {
    //                   for (const f of group.availableTimes) {
    //                     if (f.time === slotTime.time) {
    //                       this.preferredDateAndTime = f;
    //                       this.selectedHourGroup = group;
    //                     }
    //                   }
    //                 }
    //               }
    //               else {
    //                 this.preferredDateAndTime = null;
    //               }
    //               className = 'meeting k-state-selected';
    //             }
    //             else if (setTodayDate &&
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.minDate) &&
    //               !this.isDateBlocked(date)) {
    //               this.selectedSlot = a;
    //               className = 'meeting k-state-selected';
    //             }
    //             else if (
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               a.availableTimes.length > 0 &&
    //               !this.isDateBlocked(date)) {
    //               className = 'meeting';
    //             }
    //             else if (
    //               this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
    //               (a.availableTimes.length === 0 ||
    //                 this.isDateBlocked(date))) {
    //               className = 'no-schedule';
    //             }
    //           }
    //           e.className = className;
    //         });

    //       },
    //       error => {
    //         this.app.spinner.hide();
    //         this.showErrorMessage(error);
    //       });
    // }
  }

  isDateBlocked(date: Date): boolean {
    let isPromo = false;
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      isPromo = this.selectedTreatment[a].isPromo;
    }
    if (this.app.config.disableWeekDays != null && this.app.config.disableWeekDays.length > 0) {
      for (const weekDay of this.app.config.disableWeekDays) {
        if (weekDay === date.getDay() && isPromo) {
          return true;
        }
      }
    }
    return false;
  }

  getAvailableSlotPerDay(selectedDate: string, slotDate: any = null): void {
    this.isConfirmButtonIsDisabled = true;

    const treatments = [];
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      const treatment = {
        treatmentId: this.selectedTreatment[a].treatmentId,
        staffId: this.selectedTherapist.therapistId,
        requiredTimes: null
      };

      if (this.app.stringService.isNotEmpty(this.selectedTherapist.consultationTimes) &&
        this.hasNewClientTreatment) {
        treatment.requiredTimes = this.selectedTherapist.consultationTimes;
      }
      treatments.push(treatment);
    }

    const maxGuestCount = 1;

    const m = {
      treatments,
      branchId: this.app.branch.branchId,
      preferredDate: selectedDate,
      guestCount: maxGuestCount
    };
    this.app.spinner.show();
    this.app.loadingDescription = 'Checking available time...';
    this.app.webBookingService.GetAvailableSlotPerDay(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          if (data != null && data.length > 0) {
            this.preferredDateAndTime = null;
            this.selectedSlot = data[0];
            this.selectedHourGroup = this.selectedSlot.timeGroupings[0];
            let slotTime = null;
            if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTime))){
              slotTime = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTime)) as AvailableTime;
            }
            if (
              this.selectedSlot != null &&
              slotDate != null &&
              slotTime != null &&
              this.selectedSlot.availableTimes != null) {
              for (const f of this.selectedSlot.availableTimes) {
                if (f.time === slotTime.time) {
                  this.preferredDateAndTime = f;
                }
              }
            }
            else {
              this.preferredDateAndTime = null;
            }
          }
          else {
            this.selectedSlot = null;
          }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });


  }

  onCellEnter(value: Date): void {
  }

  onCellLeave(value: Date): void {
  }

  onChange(value: Date): void {
  }

  onActiveViewChange(value: string): void {
    if (value.toLowerCase() !== 'month') { return; }
    setTimeout(() => {
      this.selectedSlot = null;
      this.getStartAndEndDate(true);
    }, 30);
  }

  onPreferredDateClick(availableDateTimeAndSlot: AvailableTime): void {
    this.preferredDateAndTime = availableDateTimeAndSlot;
    this.isConfirmButtonIsDisabled = false;

    // Pass Seven Functionality
    const selectedDate = this.app.dateService.getNewDate(this.preferredDateAndTime.time);
    this.isPassSeven = selectedDate.getHours() >= 19;
  }

  onPreferredHourClick(hour): void {
    this.selectedHour = hour;
  }

  onPreferredHourGroupClick(hour): void {
    this.selectedHourGroup = hour;
  }

  onBlur(): void {
  }

  onFocus(): void {
  }

  next(): void {
    if (this.preferredDateAndTime === null) {
      this.showErrorMessage('Please select preferred time.');
      return;
    }
    this.app.storageService.setItem(AppConstants.BookingSelectedDate, JSON.stringify(this.selectedSlot));
    this.app.storageService.setItem(AppConstants.BookingSelectedTime, JSON.stringify(this.preferredDateAndTime));
    this.bookAppointment();
  }

  bookAppointment(withVoucher: boolean = false): void {
    let customerId = '';
    if (this.app.customer != null) {
      customerId = this.app.customer.customerId;
    }
    const treatments = [];
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      const treatment = {
        treatmentId: this.selectedTreatment[a].treatmentId
      };
      treatments.push(treatment);
    }
    const maxGuestCount = 1;

    const m = [];
    for (let a = 0; a < maxGuestCount; a++) {
      m.push({
        treatments,
        staffId: this.preferredDateAndTime.slots[a].staffId,
        roomId: this.preferredDateAndTime.slots[a].roomId,
        equipmentId: this.preferredDateAndTime.slots[a].equipmentId,
        time: this.preferredDateAndTime.slots[a].time,
        branchId: this.app.branch.branchId
      });
    }

    this.app.loadingDescription = 'Loading...';
    this.app.spinner.show();
    this.app.webBookingService.BookCouple(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.Appointment, JSON.stringify(data));
          this.app.storageService.setItem(AppConstants.BookingSelectedTreatment, JSON.stringify(this.selectedTreatment));

          if (this.app.basketItems == null) {
            this.app.basketItems = [];
          }

          for (let a = 0; a < this.selectedTreatment.length; a++) {

            const item: Item = new Item();
            item.giftVoucherOptionType = GiftVoucherOptionType.NotGiftVoucher;
            item.description = this.selectedTreatment[a].name;
            item.invoiceDetailType = InvoiceDetailType.Service;

            item.staffId = this.preferredDateAndTime.slots[0].staffId;
            item.roomId = this.preferredDateAndTime.slots[0].roomId;
            item.staffName = this.preferredDateAndTime.slots[0].staffName;
            item.bookingDate = this.preferredDateAndTime.slots[0].time;
            item.startTime = this.preferredDateAndTime.slots[0].time;
            item.endTime = this.preferredDateAndTime.slots[0].endTime;
            item.appointmentId = data[0].appointmentId;
            item.bookingReference = data[0].bookingReference;
            item.customerId = this.app.customer.customerId;

            item.quantity = 1;
            item.itemId = this.selectedTreatment[a].treatmentId;

            item.originalFee = data[0].fee;
            item.fee = data[0].depositFee;
            item.depositAmount = data[0].depositFee;
            item.depositPercentage = this.selectedTreatment[a].depositPercentage;

            this.app.basketItems.push(item);
          }

          this.app.storageService.setItem(AppConstants.GiftVoucherSelectedVouchers, JSON.stringify(this.app.basketItems));

          this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
          this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);

          this.modalRef = this.app.modalService.show(
            this.addConfirmation,
            {
              class: 'modal-dialog-centered modal-dialog-scrollable',
              ignoreBackdropClick: true,
              keyboard: false
            }
          );
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  goToSelectConsultation() {
    this.modalRef.hide();
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }

  goToCart() {
    this.modalRef.hide();
    this.app.router.navigate([AppConstants.RouteCheckout]);
  }

  back(): void {
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
  }

  payAtTheAppoitment() {
    let customerId = '';
    if (this.app.customer != null) {
      customerId = this.app.customer.customerId;
    }

    const treatments = [];
    for (let a = 0; a < this.selectedTreatment.length; a++) {
      const treatment = {
        treatmentId: this.selectedTreatment[a].treatmentId
      };
      treatments.push(treatment);
    }

    const maxGuestCount = 1;

    const m = [];
    for (let a = 0; a < maxGuestCount; a++) {
      m.push({
        treatments,
        staffId: this.preferredDateAndTime.slots[a].staffId,
        roomId: this.preferredDateAndTime.slots[a].roomId,
        equipmentId: this.preferredDateAndTime.slots[a].equipmentId,
        time: this.preferredDateAndTime.slots[a].time,
        branchId: this.app.branch.branchId
      });
    }

    this.app.loadingDescription = 'Loading...';
    this.app.spinner.show();
    this.app.webBookingService.BookCouple(m)
      .subscribe(
        data => {
          this.confirmAppointment(data);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  confirmAppointment(appointments): void {
    const ids = [];
    for (const appointment of appointments) {
      ids.push(appointment.appointmentId);
    }
    const m = {
      appointmentIds: ids,
      branchId: this.app.branch.branchId,
      customerId: this.app.customer.customerId,
      token: JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token,
      isSecured: false,
      externalGiftVoucherNumber: "",
      holdAmount: 0
    };
    this.app.spinner.show();
    this.app.webBookingService.ConfirmAppointment(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.AppointmentResult, JSON.stringify(appointments[0]));
          this.app.storageService.setItem(AppConstants.BookingTreatmentResult, JSON.stringify(this.selectedTreatment));
          this.app.storageService.setItem(AppConstants.BookingPractionerResult, JSON.stringify(this.selectedTherapist));
          this.app.storageService.setItem(AppConstants.BookingSlotResult, JSON.stringify(this.preferredDateAndTime));

          this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
          this.app.storageService.removeItem(AppConstants.RedirectState);
          this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
          this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
          this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
          this.app.storageService.removeItem(AppConstants.Appointment);
          this.app.storageService.removeItem(AppConstants.PendingTransaction);

          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());

          this.app.router.navigate([AppConstants.RouteThankYou]);
        },
        error => {
          this.app.spinner.hide();
          this.app.router.navigate([AppConstants.RouteSelectDate]);
          this.showErrorMessage(error);
          this.back();
        });
  }
}
